var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"element"},[_c('div',{staticClass:"label text-caption"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"status"},[_vm._v(_vm._s(_vm.status))])])}
var staticRenderFns = []

export { render, staticRenderFns }